module.exports = __webpack_public_path__ + "img/bg_resize_castle_back.ad8a0f99.webp";